import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  collection,
  query,
  where,
  getDocs,
} from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { useTranslation } from 'react-i18next';
import './ManageClinics.css'; // reuse styles

const ClinicDashboard = () => {
  const { clinicToken } = useParams(); // ✅ clearer and specific
  const { t } = useTranslation();
  const [clinic, setClinic] = useState(null);
  const [visits, setVisits] = useState([]);

  useEffect(() => {
    const loadClinic = async () => {
      const clinicSnap = await getDocs(
        query(collection(db, 'clinics'), where('token', '==', clinicToken))
      );

      if (!clinicSnap.empty) {
        const clinicData = { id: clinicSnap.docs[0].id, ...clinicSnap.docs[0].data() };
        setClinic(clinicData);

        const visitsSnap = await getDocs(
          query(collection(db, 'clinic_visits'), where('clinic_id', '==', clinicData.id))
        );

        const visitData = await Promise.all(
          visitsSnap.docs.map(async (doc) => {
            const visit = doc.data();
            let customerName = 'Unknown';

            const customerSnap = await getDocs(
              query(collection(db, 'customers'), where('token', '==', visit.customer_token))
            );
            if (!customerSnap.empty) {
              customerName = customerSnap.docs[0].data().name;
            }

            return {
              ...visit,
              customer_name: customerName,
              visited_at: visit.visited_at?.toDate?.().toLocaleString?.() || 'N/A',
            };
          })
        );

        setVisits(visitData);
      }
    };

    loadClinic();
  }, [clinicToken]);

  const exportCSV = () => {
    const headers = ['Customer', 'Date', 'Confirmed By'];
    const rows = visits.map(v => [
      v.customer_name,
      v.visited_at,
      v.confirmed_by_email || '',
    ]);
    const csv = [headers, ...rows].map(r => r.map(cell => `"${cell}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'clinic_dashboard_visits.csv';
    link.click();
  };

  if (!clinic) return <p>{t('loading')}...</p>;

  return (
    <div className="manage-clinics-container">
      <div className="text-center mt-6" />
      <h2 className="manage-clinics-title">📍 {clinic.name} - {t('clinicDashboard.visitLog')}</h2>

      <div className="text-right mb-4">
        <button className="clinic-action-btn export-btn" onClick={exportCSV}>
          {t('clinicDashboard.exportCsv')}
        </button>
      </div>

      <p className="text-lg font-semibold mt-4">
        {t('clinicDashboard.totalVisits')}: {visits.length}
      </p>

      <div className="clinic-list">
        {visits.map((v, idx) => (
          <div key={idx} className="clinic-card">
            <div className="clinic-card-info">
              <p><strong>{t('clinicVisits.customer')}:</strong> {v.customer_name}</p>
              <p><strong>{t('clinicVisits.date')}:</strong> {v.visited_at}</p>
              <p><strong>{t('clinicVisits.confirmedBy')}:</strong> {v.confirmed_by_email || 'N/A'}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClinicDashboard;